<template>
    <div>
        <activix-select
            class="nav-select"
            :autosize="true"
            :options="teamOptions"
            :placeholder="$t('multiselect.selectOption')"
            v-model="selectedTeamId"
        />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'pinia';
    import { ActivixSelect } from '@/components/activix-ui/index.ts';
    import { useUserStore } from '@/store/modules/user/store.js';
    import { useAccountStore } from '@/store/modules/account/store.js';
    import { useContextStore } from '../store/modules/context/store.ts';

    export default {
        components: {
            ActivixSelect,
        },

        data() {
            return {
                selectedTeamId: null,
            };
        },

        computed: {
            ...mapState(useContextStore, {
                contextTeam: 'contextTeam',
            }),

            contextAccount() {
                return useAccountStore().contextAccount;
            },

            teamOptions() {
                return [
                    {
                        value: null,
                        label: this.$t('general.allTeams'),
                    },
                    ...this.contextAccount.activeTeams.map((team) => {
                        return {
                            value: team.id,
                            label: team.name || `${this.$t('general.team')} ${team.number}`,
                        };
                    }),
                ];
            },
        },

        watch: {
            'contextTeam.id': {
                immediate: true,
                handler() {
                    this.selectedTeamId = this.contextTeam.id || null;
                },
            },

            selectedTeamId() {
                this.setContextTeamId(this.selectedTeamId);
                this.updateSession('team_id', this.selectedTeamId);
            },
        },
        methods: {
            ...mapActions(useContextStore, ['setContextTeamId']),
            ...mapActions(useUserStore, ['updateSession']),
        },
    };
</script>
